import { createFileRoute } from '@tanstack/react-router';
import { CrmArticlesPage } from '@pages/crm';

export const Route = createFileRoute('/$locale/_authenticated/crm/helpdesk/articles/')({
  component: ArticlesRoute,
});
function ArticlesRoute() {
  const { locale } = Route.useParams();
  return <CrmArticlesPage locale={locale} search={Route.useSearch()} />;
}
